document.querySelectorAll('.custom-select__btn').forEach(el => {
  el.addEventListener('click', function () {
    const marketList = el.nextElementSibling
    marketList.classList.remove('hidden')
  })
  window.onclick = e => {
    const openList = document.querySelectorAll('.custom-select__listbox')
    openList.forEach(el => {
      if (!e.target.classList.contains('custom-select__btn') ) {
        el.classList.add('hidden')
      }
    })
  }
})
